import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "63",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"18\" height=\"20\" x=\".667\" fill=\"#528BFF\" rx=\"4\"></rect><rect width=\"18\" height=\"20\" x=\"22.667\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"18\" height=\"20\" x=\"44.667\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"18\" height=\"20\" x=\".667\" y=\"24\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"18\" height=\"20\" x=\"22.667\" y=\"24\" fill=\"#EAECF0\" rx=\"4\"></rect><rect width=\"18\" height=\"20\" x=\"44.667\" y=\"24\" fill=\"#EAECF0\" rx=\"4\"></rect>", 6)
  ])))
}
export default { render: render }